import React, {useState} from 'react';

import {CheckboxButton} from 'app/general/widgets/CheckboxButton';
import {
  useAccountSettingsState,
  useUpdateAccountSettings,
} from 'app/settings/api';
import {gt} from 'app/utils/i18n';

export function SweetAICertificate() {
  const {account_id, require_ai_data_sharing_at} =
    useAccountSettingsState().data!;
  const [isEnabled, setIsEnabled] = useState(require_ai_data_sharing_at);
  const [updateAccountSettings] = useUpdateAccountSettings();

  const handleToggle = async () => {
    const newStatus = !isEnabled;
    setIsEnabled(newStatus);

    try {
      await updateAccountSettings({
        require_ai_data_sharing_at: newStatus,
        account_id,
      });
    } catch (error) {
      setIsEnabled(!newStatus); // revert if mutation fails
    }
  };

  return (
    <div className="mt-4 py-2 px-4 border rounded">
      <div className="d-flex justify-content-between align-items-center pl-1">
        {isEnabled ? (
          <h4 className="font-weight-bold mb-0">
            <i className="text-success mr-2 far fa-robot" />
            {gt('SweetAI is enabled on your account')}
          </h4>
        ) : (
          <h4 className="font-weight-bold text-danger">
            <i className="text-warning mr-2 fa fa-exclamation-triangle" />
            {gt('SweetAI is disabled on this account')}
          </h4>
        )}

        <div className="d-flex align-items-center">
          <label htmlFor="aiToggle" className="mb-0">
            {isEnabled ? gt('Disable SweetAI') : gt('Enable SweetAI')}
          </label>
          <CheckboxButton
            id="aiToggle"
            isChecked={!isEnabled}
            onClick={handleToggle}
            className="mr-1 btn btn-lg btn-link"
          />
        </div>
      </div>
      {!isEnabled ? (
        <div>
          <p>{gt("By disabling AI, you won't have access to:")}</p>
          <ul>
            <li>{gt('Procedure and policy suggestions')}</li>
            <li>{gt('AI-assisted documentation')}</li>
            <li>{gt('Procedures and policies tailored to your industry')}</li>
            <li>
              {gt(
                'Discussion with SweetAI for specific documentation improvements'
              )}
            </li>
          </ul>
          <p>{gt('Re-enable SweetAI to unlock these features.')}</p>
        </div>
      ) : null}
    </div>
  );
}
